import { OPERATOR_EQUAL, OPERATOR_IN } from '@/class/cargo/model/utils/AdvancedSearchConsts'

/**
 * REQ-0012 方案A（前端收敛）：目的港服务查询条件不再在前端分解。
 *
 * 前端只把虚拟字段 `job.portOfDestinationServices` 作为**一条**条件下发——
 * `operator`（IN=包含 / '='=等于）+ `value`（所选 code 数组，如 ['1','2']）原样随查询数据下发，
 * 由后端 `JobUtil.buildDestinationPortServiceCondition` 拦截该虚拟字段，按 operator 自己拼 OR（包含）/ AND（等于）。
 *
 * 故本模块不再保留任何"分解成 per-flag"的组装逻辑（旧 `DESTINATION_SERVICE_OP`、
 * `buildDestinationServiceConditions`、`assembleDestinationServiceConditions`、`convertDestinationServiceConditions`、
 * `CODE_TO_FLAG` 已全部废弃）。operator 复用既有词表 `OPERATOR_IN`(包含)/`OPERATOR_EQUAL`(等于)，
 * 不再自造 INCLUDE/EQUALS。
 */

/**
 * 为目的港服务字段挂"包含/等于"操作符下拉的字段配置（纯函数，可单测）。
 *
 * 输入后端全局查询配置里的原始字段（itemName='job.portOfDestinationServices'），返回带操作符下拉的
 * 新字段对象（不修改原对象）。调用方（bookingTreeGrid）再补 `action = UPDATE_ACTION` 并 push。
 *
 * - `itemCondition`：复用既有 `OPERATOR_IN`(code 'IN'，标签"包含")/`OPERATOR_EQUAL`(code '='，标签"等于")，
 *   不再自造 INCLUDE/EQUALS（见 DESIGN §4 问题②）。两个都是 CommonState 实例，自带 code/englishName，
 *   与系统其它字段 itemCondition 写法一致。
 * - `defaultConditionVal`：默认 `OPERATOR_IN.code`（'IN'，包含）——回归保护，等价于改动前默认"包含"。
 * - `multiple: 1`（**保留**，gate7 修复）：目的港服务本就是多选（一个 job 可同时有多个服务），
 *   UI 多选所选的全部 code 必须都能进入 value 数组下发。后端全局查询配置若未把该字段置为多选
 *   （multiple!==1），静态下拉（cargoCombinationSearch `itemType==='select'` 分支 `:multiple="item.multiple===1"`）
 *   会渲染成单选，用户只能选一个 code → 等于{清关,派车} 实际只有清关到达 value → 等集错位。
 *
 * @param {Object} originField 后端全局查询配置里的原始字段
 * @returns {Object} 新字段对象（含 itemCondition/defaultConditionVal/multiple=1）
 */
export function buildDestinationServiceFieldConfig(originField) {
  return {
    ...originField,
    itemCondition: [OPERATOR_IN, OPERATOR_EQUAL],
    defaultConditionVal: OPERATOR_IN.code,
    multiple: 1
  }
}
